import { RateAndReviewForm } from '../rateAndReviewForm/rateAndReviewForm';
import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';
import type { RateAndReviewModalVariantProps } from '../rateAndReviewModalVariant';
import { ReviewProductHeader } from '../reviewProductHeader/reviewProductHeader';
import { ReviewSubmitFailed } from '../reviewSubmitFailed/reviewSubmitFailed';
import { ReviewSubmitted } from '../reviewSubmitted/reviewSubmitted';

export type RateAndReviewFormModalProps = RateAndReviewModalVariantProps;

/** A/B test variant A: the modal shell with every question at once. */
export function RateAndReviewFormModal({
  activityOptions,
  brand,
  category,
  feelingOptions,
  imageUrl,
  isMobile,
  isRetryable = true,
  isSubmitting,
  moreToReview,
  onChange,
  onRequestClose,
  onReviewProduct,
  onSubmit,
  open,
  productName,
  status = 'editing',
  testId,
  title,
  value,
}: RateAndReviewFormModalProps) {
  const renderBody = () => {
    if (status === 'submitted') {
      return (
        <ReviewSubmitted
          moreToReview={moreToReview}
          onDone={onRequestClose}
          onReviewProduct={onReviewProduct}
          productName={productName}
          rating={value.rating}
        />
      );
    }
    if (status === 'failed') {
      return isRetryable ? (
        <ReviewSubmitFailed isSubmitting={isSubmitting} onRetry={onSubmit} />
      ) : (
        <ReviewSubmitFailed isRetryable={false} onClose={onRequestClose} />
      );
    }
    return (
      <RateAndReviewForm
        activityOptions={activityOptions}
        feelingOptions={feelingOptions}
        isSubmitting={isSubmitting}
        onChange={onChange}
        onSubmit={onSubmit}
        value={value}
      />
    );
  };

  return (
    <RateAndReviewModal
      isMobile={isMobile}
      onRequestClose={onRequestClose}
      open={open}
      productHeader={
        status === 'editing' && (
          <ReviewProductHeader
            brand={brand}
            category={category}
            imageUrl={imageUrl}
            name={productName}
            size="compact"
          />
        )
      }
      testId={testId}
      title={title}
    >
      {renderBody()}
    </RateAndReviewModal>
  );
}
